import { Provider } from '@angular/core';

import { provideSvgIcon } from '@/app/shared/components/ui/svg-icon';

export function provideSvgSprite(): Provider[] {
  return [provideSvgIcon({ spriteUrl: '/assets/images/icons/sprite.svg' })];
}
